import * as React from "react";
import produce from "immer";
export type ApplicationEvents =
  | "RefreshSearchTables"
  | "LanguageChanged"
  | "RefetchRoomBookings";
interface IEventsContext {
  dispatchEvent: (event: ApplicationEvents, data?: any) => void;
  subscribeToEvent: (event: ApplicationEvents, callback: CallBackType) => void;
  unsubscribeEvent: (event: ApplicationEvents, callback: CallBackType) => void;
}
const EventsContext = React.createContext<IEventsContext>(null);

interface IEventsProviderProps {
  children: React.ReactNode;
}

type CallBackType = (data?: any) => void;

export const EventsProvider: React.FunctionComponent<IEventsProviderProps> = ({
  children,
}) => {
  const [events, setEvents] = React.useState<{
    [event: string]: Array<CallBackType>;
  }>({});
  const dispatchEvent = React.useCallback(
    (event: string, data?: any) => {
      if (!events[event]) return;
      events[event].forEach((cb) => cb(data));
    },
    [events]
  );

  const subscribeToEvent = React.useCallback(
    (event: ApplicationEvents, callback: CallBackType) => {
      setEvents((prev) =>
        produce(prev, (draft) => {
          if (!draft[event]) {
            draft[event] = [];
          }
          draft[event].push(callback);
        })
      );
    },
    []
  );

  const unsubscribeEvent = React.useCallback(
    (event: ApplicationEvents, callback: CallBackType) => {
      setEvents((prev) =>
        produce(prev, (draft) => {
          if (draft[event]) {
            draft[event] = draft[event].filter((cb) => cb !== callback);
          }
        })
      );
    },
    []
  );

  return (
    <EventsContext.Provider
      value={{ dispatchEvent, subscribeToEvent, unsubscribeEvent }}
    >
      {children}
    </EventsContext.Provider>
  );
};

export const useEventsContext = () => React.useContext(EventsContext);

// export const useEventSubscribe = (event: ApplicationEvents, callback: (data: any) => void) => {
//   const { subscribeToEvent, unsubscribeEvent } = useEventsContext();

//   React.useEffect(() => {
//     subscribeToEvent(event, callback);
//     return () => unsubscribeEvent(event, callback);
//   }, [callback, event, subscribeToEvent, unsubscribeEvent]);
// };
